<template>
    <div>
        <div style="margin-top: 20px;">
            <el-table :data="list">
                <el-table-column align="center" property="name" label="网元实例名称"></el-table-column>
                <el-table-column align="center" property="server" label="设备"></el-table-column>
                <el-table-column align="center" property="moduleNum" label="模块个数"></el-table-column>
                <el-table-column align="center" label="操作" width="540">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="start(scope.row)">启动</el-button>
                        <el-button size="mini" type="primary" @click="start(scope.row)">停止</el-button>
                        <el-button size="mini" type="primary" @click="start(scope.row)">心跳中断</el-button>
                        <el-button size="mini" type="primary" @click="start(scope.row)">心跳连接</el-button>
                        <el-button size="mini" type="primary" @click="start(scope.row)">负载详情</el-button>
                        <el-button size="mini" type="primary" @click="getModuleInstance(scope.row)">模块实例</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
            class="fy"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10,20,30,40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElement"
            >
        </el-pagination>

        <el-dialog title="模块实例" width="60%"
            :visible="showInstance" @close="cancle">
            <module-instance-list :list="instanceList" />
            <div style="text-align:center;margin-top: 30px;">
                <el-button @click="cancle">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import ModuleInstanceList from './ModuleInstanceList.vue'
export default {
    name: 'NetworkUnitInstanceList',
    props: {
        list: {
            type: Array
        }
    },
    components: { ModuleInstanceList },
    data: vm => ({
        currentPage: 1,
        pageSize: 10,
        showInstance: false, //模块实例弹框
        instanceList: [], //模块实例列表
    }),
    computed: {
        totalElement(){
            return this.list.length
        }
    },
    methods: {
        handleSizeChange(){},
        handleCurrentChange(){},
        start(row){},
        // 获取模块实例
        getModuleInstance(row){
            this.showInstance = true
            this.instanceList = [{
                name: 'Qos_20191204_1',
                moduleNum: 1
            }]
        },
        cancle(){
            this.showInstance = false
        }
    }
}
</script>
<style scoped>
.divCon{
    width: 40%;
    margin: 20px 0px;
}
</style>